/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='sw1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw1'">Sw1</vs-button>
          <vs-button :color="sel==='sw2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw2'">Sw2</vs-button>
          <vs-button :color="sel==='sw3'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw3'">Sw3</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">Configure VLANs &amp; Access Ports</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/22</span>
            </div>
            <div class="px-3 py-2">

              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW1</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task1Sw1Items" :key="'sw1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                  <code class="text-base" :class="sw1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>

              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW2</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task1Sw2Items" :key="'sw2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw2Completion[item.key])"></div>
                  <code class="text-base" :class="sw2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>

              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">SW3</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task1Sw3Items" :key="'sw3-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw3Completion[item.key])"></div>
                  <code class="text-base" :class="sw3Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>

            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">Trunk e0/2 — Sw1 &amp; Sw2 (VLAN 210 only)</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/8</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2']" :key="'t2-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swk.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task2Items" :key="'t2-'+swk+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">Trunk e0/3 — Sw2 &amp; Sw3 (VLANs 110, 210)</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Progress }}/8</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw2','sw3']" :key="'t3-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swk.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task3Items" :key="'t3-'+swk+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk)[item.key])"></div>
                    <code class="text-base" :class="getComp(swk)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [sw1Completion.saved,sw2Completion.saved,sw3Completion.saved].filter(Boolean).length }}/3</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swk in ['sw1','sw2','sw3']" :key="'s-'+swk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swk.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(swk).saved)"></div>
                    <code class="text-base" :class="getComp(swk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='sw1'" key="sw1" id="sw1_terminal" :commands="sw1Commands" :prompt="sw1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW1" />
          <vue-command v-show="sel==='sw2'" key="sw2" id="sw2_terminal" :commands="sw2Commands" :prompt="sw2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW2" />
          <vue-command v-show="sel==='sw3'" key="sw3" id="sw3_terminal" :commands="sw3Commands" :prompt="sw3Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW3" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist.';

const mkCommands = (swk, vm) => ({
  help:       () => createStdout(HELP),
  enable:     () => vm.iosEnable(swk),
  configure:  (x) => vm.iosConfigure(swk, x),
  conf:       (x) => vm.iosConfigure(swk, x),
  vlan:       (x) => vm.iosVlan(swk, x),
  name:       (x) => vm.iosName(swk, x),
  interface:  (x) => vm.iosInterface(swk, x),
  int:        (x) => vm.iosInterface(swk, x),
  switchport: (x) => vm.iosSwitchport(swk, x),
  exit:       () => vm.iosExit(swk),
  end:        () => vm.iosEnd(swk),
  copy:       (x) => vm.iosCopy(swk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/VLAN_and_Trunking_Configuration_Sim.png',
      sel: 'sw1',
      totalScore: 0,

      sw1: { mode: 'exec', currentVlan: null, currentIf: null },
      sw2: { mode: 'exec', currentVlan: null, currentIf: null },
      sw3: { mode: 'exec', currentVlan: null, currentIf: null },

      // sw1: vlan210(2) + fa01(3) + fa02(4) + saved(1) = 10
      sw1Completion: {
        vlan210: false, vlan210Name: false,
        fa01If: false, fa01Access: false, fa01Vlan: false,
        fa02If: false, fa02Encap: false, fa02Trunk: false, fa02Allowed: false,
        saved: false,
      },
      // sw2: vlan110(2) + vlan210(2) + fa01(3) + fa02(4) + fa03(4) + saved(1) = 16
      sw2Completion: {
        vlan110: false, vlan110Name: false,
        vlan210: false, vlan210Name: false,
        fa01If: false, fa01Access: false, fa01Vlan: false,
        fa02If: false, fa02Encap: false, fa02Trunk: false, fa02Allowed: false,
        fa03If: false, fa03Encap: false, fa03Trunk: false, fa03Allowed: false,
        saved: false,
      },
      // sw3: vlan110(2) + vlan210(2) + fa02(3) + fa01(3) + fa03(4) + saved(1) = 15
      sw3Completion: {
        vlan110: false, vlan110Name: false,
        vlan210: false, vlan210Name: false,
        fa02If: false, fa02Access: false, fa02Vlan: false,
        fa01If: false, fa01Access: false, fa01Vlan: false,
        fa03If: false, fa03Encap: false, fa03Trunk: false, fa03Allowed: false,
        saved: false,
      },

      sw1Commands: null,
      sw2Commands: null,
      sw3Commands: null,

      // Task 1 checklist items — one entry per command typed
      task1Sw1Items: [
        { key: 'vlan210',     label: 'vlan 210' },
        { key: 'vlan210Name', label: 'name FINANCE' },
        { key: 'fa01If',      label: 'interface e0/1' },
        { key: 'fa01Access',  label: 'switchport mode access' },
        { key: 'fa01Vlan',    label: 'switchport access vlan 210' },
      ],
      task1Sw2Items: [
        { key: 'vlan110',     label: 'vlan 110' },
        { key: 'vlan110Name', label: 'name MARKETING' },
        { key: 'vlan210',     label: 'vlan 210' },
        { key: 'vlan210Name', label: 'name FINANCE' },
        { key: 'fa01If',      label: 'interface e0/1' },
        { key: 'fa01Access',  label: 'switchport mode access' },
        { key: 'fa01Vlan',    label: 'switchport access vlan 110' },
      ],
      task1Sw3Items: [
        { key: 'vlan110',     label: 'vlan 110' },
        { key: 'vlan110Name', label: 'name MARKETING' },
        { key: 'vlan210',     label: 'vlan 210' },
        { key: 'vlan210Name', label: 'name FINANCE' },
        { key: 'fa02If',      label: 'interface e0/0' },
        { key: 'fa02Access',  label: 'switchport mode access' },
        { key: 'fa02Vlan',    label: 'switchport access vlan 110' },
        { key: 'fa01If',      label: 'interface e0/1' },
        { key: 'fa01Access',  label: 'switchport mode access' },
        { key: 'fa01Vlan',    label: 'switchport access vlan 210' },
      ],

      // Task 2 & 3 checklist items — shared across switches in each task
      task2Items: [
        { key: 'fa02If',      label: 'interface e0/2' },
        { key: 'fa02Encap',   label: 'switchport trunk encapsulation dot1q' },
        { key: 'fa02Trunk',   label: 'switchport mode trunk' },
        { key: 'fa02Allowed', label: 'switchport trunk allowed vlan 210' },
      ],
      task3Items: [
        { key: 'fa03If',      label: 'interface e0/3' },
        { key: 'fa03Encap',   label: 'switchport trunk encapsulation dot1q' },
        { key: 'fa03Trunk',   label: 'switchport mode trunk' },
        { key: 'fa03Allowed', label: 'switchport trunk allowed vlan 110,210' },
      ],
    };
  },

  computed: {
    sw1Prompt() {
      const m = this.sw1.mode;
      if (m === 'config-vlan') return 'SW1(config-vlan)#';
      if (m === 'config-if')   return 'SW1(config-if)#';
      if (m === 'config')      return 'SW1(config)#';
      return 'SW1#';
    },
    sw2Prompt() {
      const m = this.sw2.mode;
      if (m === 'config-vlan') return 'SW2(config-vlan)#';
      if (m === 'config-if')   return 'SW2(config-if)#';
      if (m === 'config')      return 'SW2(config)#';
      return 'SW2#';
    },
    sw3Prompt() {
      const m = this.sw3.mode;
      if (m === 'config-vlan') return 'SW3(config-vlan)#';
      if (m === 'config-if')   return 'SW3(config-if)#';
      if (m === 'config')      return 'SW3(config)#';
      return 'SW3#';
    },

    // task1: sw1(5) + sw2(7) + sw3(10) = 22
    task1Progress() {
      const c1 = this.sw1Completion, c2 = this.sw2Completion, c3 = this.sw3Completion;
      return [
        c1.vlan210, c1.vlan210Name, c1.fa01If, c1.fa01Access, c1.fa01Vlan,
        c2.vlan110, c2.vlan110Name, c2.vlan210, c2.vlan210Name, c2.fa01If, c2.fa01Access, c2.fa01Vlan,
        c3.vlan110, c3.vlan110Name, c3.vlan210, c3.vlan210Name, c3.fa02If, c3.fa02Access, c3.fa02Vlan, c3.fa01If, c3.fa01Access, c3.fa01Vlan,
      ].filter(Boolean).length;
    },
    task1Done() { return this.task1Progress === 22; },

    // task2: sw1(4) + sw2(4) = 8
    task2Progress() {
      const c1 = this.sw1Completion, c2 = this.sw2Completion;
      return [c1.fa02If, c1.fa02Encap, c1.fa02Trunk, c1.fa02Allowed,
              c2.fa02If, c2.fa02Encap, c2.fa02Trunk, c2.fa02Allowed].filter(Boolean).length;
    },
    task2Done() {
      return this.sw1Completion.fa02Trunk && this.sw1Completion.fa02Allowed &&
             this.sw2Completion.fa02Trunk && this.sw2Completion.fa02Allowed;
    },

    // task3: sw2(4) + sw3(4) = 8
    task3Progress() {
      const c2 = this.sw2Completion, c3 = this.sw3Completion;
      return [c2.fa03If, c2.fa03Encap, c2.fa03Trunk, c2.fa03Allowed,
              c3.fa03If, c3.fa03Encap, c3.fa03Trunk, c3.fa03Allowed].filter(Boolean).length;
    },
    task3Done() {
      return this.sw2Completion.fa03Trunk && this.sw2Completion.fa03Allowed &&
             this.sw3Completion.fa03Trunk && this.sw3Completion.fa03Allowed;
    },

    saveDone() { return this.sw1Completion.saved && this.sw2Completion.saved && this.sw3Completion.saved; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.sw1Commands = mkCommands('sw1', this);
    this.sw2Commands = mkCommands('sw2', this);
    this.sw3Commands = mkCommands('sw3', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },

    dot(val) {
      return { width: '8px', height: '8px', background: val ? '#28C76F' : 'transparent', border: '2px solid ' + (val ? '#28C76F' : '#6b7280') };
    },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    switchTo(sw) {
      this.sel = sw;
      this.$nextTick(() => {
        const el = document.querySelector(`#${sw}_terminal input, #${sw}_terminal textarea`);
        if (el) el.focus();
      });
    },

    normalizeIf(ifStr) {
      return (ifStr || '').toLowerCase()
        .replace(/^fastethernet/, '')
        .replace(/^ethernet/, '')
        .replace(/^fa/, '')
        .replace(/^e(?=\d)/, '')
        .trim();
    },

    updateScore() {
      let score = 0;
      [this.sw1Completion, this.sw2Completion, this.sw3Completion].forEach(c =>
        Object.values(c).forEach(v => { if (v) score++; })
      );
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      // sw1(10) + sw2(16) + sw3(15) = 41
      if (score >= 41) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(swk) {
      this[swk].mode = 'exec';
      return createStdout('');
    },

    iosConfigure(swk, x) {
      const s = this[swk];
      if (s.mode !== 'exec') return createStderr('% Already in configuration mode — type "end" to return to exec first');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        s.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(swk) {
      const s = this[swk];
      if (s.mode === 'config-if' || s.mode === 'config-vlan') {
        s.mode = 'config';
        s.currentVlan = null;
        s.currentIf = null;
      } else if (s.mode === 'config') {
        s.mode = 'exec';
      }
      return createStdout('');
    },

    iosEnd(swk) {
      this[swk].mode = 'exec';
      this[swk].currentVlan = null;
      this[swk].currentIf = null;
      return createStdout('');
    },

    iosVlan(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config' && s.mode !== 'config-vlan') {
        return createStderr('% Invalid input detected — must be in global or VLAN configuration mode');
      }
      const vlanId = String(x._[1] || '');
      if (!vlanId || isNaN(vlanId)) return createStderr('% Invalid input detected');

      s.mode = 'config-vlan';
      s.currentVlan = vlanId;
      s.currentIf = null;

      const c = this[swk + 'Completion'];
      if (vlanId === '110' && (swk === 'sw2' || swk === 'sw3') && !c.vlan110) {
        c.vlan110 = true; this.updateScore();
      } else if (vlanId === '210' && !c.vlan210) {
        c.vlan210 = true; this.updateScore();
      }

      return createStdout('');
    },

    iosName(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config-vlan') return createStderr('% Invalid input detected — must be in VLAN configuration mode');
      const nameRaw = (x._[1] || '');
      if (!nameRaw) return createStderr('% Invalid input detected');
      const nameUp = nameRaw.toUpperCase();
      const c = this[swk + 'Completion'];

      if (s.currentVlan === '110' && nameUp === 'MARKETING' && !c.vlan110Name) {
        c.vlan110Name = true; this.updateScore();
        return createStdout(this.guide(
          'VLAN 110 named MARKETING. A VLAN must exist in the local database before the switch will forward tagged frames for it — even if no local access port is assigned to that VLAN. ' +
          'SW2 needs VLAN 210 for exactly this reason: no FINANCE PC is attached to SW2, but without VLAN 210 in its database, SW2 would drop FINANCE frames instead of forwarding them across the trunk. ' +
          '→ Create VLAN 210 next: "vlan 210".'
        ));
      }

      if (s.currentVlan === '210' && nameUp === 'FINANCE' && !c.vlan210Name) {
        c.vlan210Name = true; this.updateScore();
        const swName = swk.toUpperCase();
        let next = '';
        if (swk === 'sw1') next = '→ Configure the access port: "interface fa0/1".';
        else if (swk === 'sw2') next = '→ Configure the access port: "interface fa0/1".';
        else next = '→ Configure the access port: "interface fa0/2". (fa0/2 replaces e0/0 — Packet Tracer switches have no fa0/0.)';
        return createStdout(this.guide(
          `VLAN 210 named FINANCE on ${swName}. Both VLANs now exist in the local VLAN database. ` +
          'IOS only forwards frames for a VLAN after that VLAN appears in the local database. ' + next
        ));
      }

      return createStdout('');
    },

    iosInterface(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config') return createStderr('% Invalid input detected — must be in global configuration mode');
      let ifArg = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) ifArg = ifArg + x._[2];
      let ifNorm = this.normalizeIf(ifArg);

      // Sw3: e0/0 is replaced by fa0/2 in Packet Tracer
      if (swk === 'sw3' && ifNorm === '0/0') ifNorm = '0/2';

      s.mode = 'config-if';
      s.currentIf = ifNorm;
      s.currentVlan = null;

      const c = this[swk + 'Completion'];
      if (ifNorm === '0/1' && !c.fa01If) { c.fa01If = true; this.updateScore(); }
      else if (ifNorm === '0/2' && !c.fa02If) { c.fa02If = true; this.updateScore(); }
      else if (ifNorm === '0/3' && !c.fa03If) { c.fa03If = true; this.updateScore(); }

      return createStdout('');
    },

    iosSwitchport(swk, x) {
      const s = this[swk];
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      const c = this[swk + 'Completion'];
      const sub1 = (x._[1] || '').toLowerCase();
      const sub2 = (x._[2] || '').toLowerCase();
      const sub3 = (x._[3] || '').toLowerCase();
      const vlanList = x._.slice(4).join('').replace(/\s/g, '');
      const ifn = s.currentIf;

      // switchport mode access
      if (sub1 === 'mode' && sub2 === 'access') {
        if (swk === 'sw1' && ifn === '0/1' && !c.fa01Access) {
          c.fa01Access = true; this.updateScore();
          return createStdout(this.guide('fa0/1 set to access mode on SW1. Access mode strips 802.1Q tags — the connected PC sends and receives untagged frames. → "switchport access vlan 210".'));
        }
        if (swk === 'sw2' && ifn === '0/1' && !c.fa01Access) {
          c.fa01Access = true; this.updateScore();
          return createStdout(this.guide('fa0/1 set to access mode on SW2. → "switchport access vlan 110".'));
        }
        if (swk === 'sw3' && ifn === '0/2' && !c.fa02Access) {
          c.fa02Access = true; this.updateScore();
          return createStdout(this.guide('fa0/2 set to access mode on SW3. This interface replaces e0/0 (Packet Tracer switches have no fa0/0). → "switchport access vlan 110".'));
        }
        if (swk === 'sw3' && ifn === '0/1' && !c.fa01Access) {
          c.fa01Access = true; this.updateScore();
          return createStdout(this.guide('fa0/1 set to access mode on SW3. → "switchport access vlan 210".'));
        }
        return createStdout('');
      }

      // switchport mode trunk
      if (sub1 === 'mode' && sub2 === 'trunk') {
        if ((swk === 'sw1' || swk === 'sw2') && ifn === '0/2' && !c.fa02Trunk) {
          c.fa02Trunk = true; this.updateScore();
          return createStdout(this.guide(
            `${swk.toUpperCase()} fa0/2 set to trunk mode. Trunk mode carries multiple VLANs using 802.1Q tags. ` +
            'By default IOS allows ALL active VLANs on a trunk — the next command restricts it to only VLAN 210. ' +
            '→ "switchport trunk allowed vlan 210".'
          ));
        }
        if ((swk === 'sw2' || swk === 'sw3') && ifn === '0/3' && !c.fa03Trunk) {
          c.fa03Trunk = true; this.updateScore();
          return createStdout(this.guide(
            `${swk.toUpperCase()} fa0/3 set to trunk mode. This trunk between SW2 and SW3 must carry both VLANs 110 and 210. ` +
            '→ "switchport trunk allowed vlan 110,210".'
          ));
        }
        return createStdout('');
      }

      // switchport trunk encapsulation dot1q
      if (sub1 === 'trunk' && sub2 === 'encapsulation' && sub3 === 'dot1q') {
        if ((swk === 'sw1' || swk === 'sw2') && ifn === '0/2' && !c.fa02Encap) {
          c.fa02Encap = true; this.updateScore();
          return createStdout(this.guide(
            '802.1Q encapsulation set for fa0/2. On switches that support both ISL and 802.1Q, this command selects the IEEE-standard method. ' +
            'On switches that only support 802.1Q this command may not exist — safe to skip if IOS reports it as invalid. ' +
            '→ "switchport mode trunk".'
          ));
        }
        if ((swk === 'sw2' || swk === 'sw3') && ifn === '0/3' && !c.fa03Encap) {
          c.fa03Encap = true; this.updateScore();
          return createStdout(this.guide('802.1Q encapsulation set for fa0/3. → "switchport mode trunk".'));
        }
        return createStdout('');
      }

      // switchport trunk allowed vlan <list>
      if (sub1 === 'trunk' && sub2 === 'allowed' && sub3 === 'vlan') {
        if ((swk === 'sw1' || swk === 'sw2') && ifn === '0/2' && vlanList === '210' && !c.fa02Allowed) {
          c.fa02Allowed = true; this.updateScore();
          const next = swk === 'sw1'
            ? '→ Switch to SW2 and configure the same trunk on fa0/2.'
            : '→ Configure Task 3: "interface fa0/3" on SW2.';
          return createStdout(this.guide(
            `${swk.toUpperCase()} fa0/2 trunk restricted to VLAN 210 only. ` +
            'The SW1–SW2 link only carries FINANCE traffic — VLAN 110 has no traffic on this segment so excluding it reduces the broadcast domain and prevents unintended VLAN leakage. ' + next
          ));
        }
        if ((swk === 'sw2' || swk === 'sw3') && ifn === '0/3' &&
            (vlanList === '110,210' || vlanList === '210,110') && !c.fa03Allowed) {
          c.fa03Allowed = true; this.updateScore();
          const next = swk === 'sw2'
            ? '→ Switch to SW3 and configure the same trunk on fa0/3.'
            : '→ Save all switches: "end" then "copy running-config startup-config" on each.';
          return createStdout(this.guide(
            `${swk.toUpperCase()} fa0/3 trunk allows VLANs 110 and 210. ` +
            'Both VLANs must traverse this SW2–SW3 link because SW3 hosts PCs in both MARKETING (fa0/2) and FINANCE (fa0/1). ' + next
          ));
        }
        return createStdout('');
      }

      // switchport access vlan <id>
      if (sub1 === 'access' && sub2 === 'vlan') {
        const vlanId = String(x._[3] || '');
        if (swk === 'sw1' && ifn === '0/1' && vlanId === '210' && !c.fa01Vlan) {
          c.fa01Vlan = true; this.updateScore();
          return createStdout(this.guide(
            'fa0/1 assigned to VLAN 210 (FINANCE) on SW1. Untagged frames from the PC are internally tagged as VLAN 210 by the switch. ' +
            '→ Configure Task 2: "interface fa0/2" to set up the 802.1Q trunk toward SW2.'
          ));
        }
        if (swk === 'sw2' && ifn === '0/1' && vlanId === '110' && !c.fa01Vlan) {
          c.fa01Vlan = true; this.updateScore();
          return createStdout(this.guide(
            'fa0/1 on SW2 assigned to VLAN 110 (MARKETING). ' +
            '→ Configure Task 2: "interface fa0/2" to set up the trunk toward SW1.'
          ));
        }
        if (swk === 'sw3' && ifn === '0/2' && vlanId === '110' && !c.fa02Vlan) {
          c.fa02Vlan = true; this.updateScore();
          return createStdout(this.guide(
            'fa0/2 (replaces e0/0) on SW3 assigned to VLAN 110 (MARKETING). ' +
            '→ Configure fa0/1 for VLAN 210: "interface fa0/1".'
          ));
        }
        if (swk === 'sw3' && ifn === '0/1' && vlanId === '210' && !c.fa01Vlan) {
          c.fa01Vlan = true; this.updateScore();
          return createStdout(this.guide(
            'fa0/1 on SW3 assigned to VLAN 210 (FINANCE). SW3 now serves both VLANs — fa0/2 for MARKETING, fa0/1 for FINANCE. ' +
            '→ Configure Task 3: "interface fa0/3" to set up the trunk toward SW2.'
          ));
        }
        return createStdout('');
      }

      return createStderr('% Invalid input detected');
    },

    iosCopy(swk, x) {
      const s = this[swk];
      if (s.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      const c = this[swk + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout(
          'Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(
            `${swk.toUpperCase()} configuration saved to NVRAM. On reboot the switch loads this exact configuration. ` +
            (this.saveDone ? '✓ All switches saved — simulation complete!' : '→ Save the remaining switches.')
          )
        );
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#sw1_terminal, #sw2_terminal, #sw3_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

